import * as service from './services'
import to from 'await-to-js'

export const state = {
  rede: null,
  redeAdmin: null
}

export const getters = {
  rede: state => {
    if (state.rede !== null) {
      return state.rede
    }

    let redeLocal = window.localStorage.getItem('rede')
    if (redeLocal) {
      return JSON.parse(redeLocal)
    }
  },
  redeAdmin: state => {
    if (state.redeAdmin !== null) {
      return state.redeAdmin
    }

    let redeAdminCache = window.localStorage.getItem('redeAdmin')
    if (redeAdminCache && redeAdminCache !== 'undefined') {
      return JSON.parse(redeAdminCache)
    }
    return null
  }
}

export const mutations = {
  setRede (state, payload) {
    state.rede = payload
  },
  setRedeAdmin (state, payload) {
    window.localStorage.setItem('redeAdmin', window.JSON.stringify(payload))
    state.redeAdmin = payload
  }
}

export const actions = {
  setRede ({ commit }, payload) {
    commit('setRede', payload)
  },
  setRedeAdmin ({commit}, payload) {
    commit('setRedeAdmin', payload)
  },
  async loadDadosRede ({dispatch}, id) {
    console.log('IdRede', id)
    const [error, response = {data: null}] = await to(service.getRede(id))
    if (error) {
      throw error
    }
    let rede = response.data
    dispatch('setRede', rede)
    console.log('SET-REDE', rede)
    window.localStorage.setItem('rede', window.JSON.stringify(rede))

    return response.data
  },
  async savePrecadastro ({dispatch}, payload) {
    const [error, response = {data: null}] = await to(service.savePrecadastro(payload))
    if (error) {
      console.log(error)
      dispatch('showErrorMsg', error)
      return Promise.reject(error)
    }

    return response.data
  },

  async ativarPrecadastro ({dispatch}, payload) {
    const [error, response = {data: null}] = await to(service.ativarPrecadastro(payload))
    if (error) {
      console.log(error)
      dispatch('showErrorMsg', error)
      return Promise.reject(error)
    }

    return response.data
  },

  async updateRede ({dispatch}, payload) {
    dispatch('setLoading', true)
    delete payload.updateAt
    delete payload.__v
    delete payload.createdAt

    if (payload.cep) {
      payload.cep = payload.cep.replace(/[-]/g, '')
    }
    if (payload.cpf) {
      payload.cpf = payload.cpf.replace(/[.-]/g, '')
    }
    if (payload.cnpj) {
      payload.cnpj = payload.cnpj.replace(/[.\-/]/g, '')
    }
    if (payload.telefoneCelular) {
      payload.telefoneCelular = payload.telefoneCelular.replace(/[.\-/(/) ]/g, '')
    }
    if (payload.telefoneFixo) {
      payload.telefoneFixo = payload.telefoneFixo.replace(/[.\-/(/) ]/g, '')
    }

    const [error, response = {data: null}] = await to(service.update(payload._id, payload))
    if (error) {
      dispatch('setLoading', false)
      throw error
    }
    dispatch('loadDadosRede', payload._id)
    dispatch('setLoading', false)
    dispatch('showSuccessMsg', {body: 'Dados da rede atualizados com Sucesso!'})
    return response.data
  },

  async listEspecialidadeRede ({getters, dispatch}) {
    const [error, response = {data: null}] = await to(service.listEspecialidadeRede(getters.rede._id))
    if (error) {
      dispatch('setLoading', false)
      throw error
    }

    return response.data
  },

  async listRedeAdmin ({getters, dispatch}) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.listAll({}))
    dispatch('setLoading', false)

    if (error) {
      dispatch('setLoading', false)
      throw error
    }

    return response.data
  },

  async listRede ({getters, dispatch}, query) {
    const [error, response = {data: null}] = await to(service.listAll(query))

    if (error) {
      throw error
    }

    return response.data
  },

  async loadUnidadePorCartaoEtipoExame ({getters}, tipoOrcamento) {
    let numeracaoInicial = ''
    if (getters.user && getters.user.cartao) {
      const nrCartao = getters.user.cartao.numeroCartao
      numeracaoInicial = nrCartao.substr(0, 4)
    } else {
      return null
    }

    const [error, response = {data: null}] = await to(
      service.getRedesPorTipoENumeracaoInicialCartao(tipoOrcamento, numeracaoInicial))

    if (error) {
      throw error
    }

    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/rede/index.js